import { Model }              from '@mathquis/modelx';
import { PublicApiConnector } from 'connectors/PublicApiConnector';
import ConfigProxy            from 'utils/ConfigProxy';

export const connector = new PublicApiConnector({
  baseURL: ConfigProxy.get('API_ENTRYPOINT'),
});

export default class PublicApiModel extends Model {
  static get connector() {
    return connector;
  }

  patch(attributes = {}, options = {}) {
    return this.save({ ...options, patchAttributes: attributes });
  }
}
